import {inject, Injectable, Signal, signal} from '@angular/core';
import {TelegramLoadFileService} from "./telegram-load-file.service";
import {LoadImageMessagesParams, SetUrlParams} from "../types/telegram-file-url.types";

@Injectable({
  providedIn: 'root'
})
export class TelegramFileUrlService {
  private telegramLoadFileService: TelegramLoadFileService = inject(TelegramLoadFileService);

  private _imageUrlsSignal = signal<Record<string, string>>({});
  public imageUrlsSignal: Signal<Record<string, string>> = this._imageUrlsSignal.asReadonly();

  public loadImageMessages({ messages, accountId }: LoadImageMessagesParams): void {
    messages?.forEach(async (message) => {
      switch (message.content?.type) {
        case 'IMAGE':
          await this.setImageUrls({
            message: message,
            accountId: accountId
          });
          break;
      }
    });
  }

  public clearAllUrls(): void {
    this._imageUrlsSignal.set({});
  }

  private async setImageUrls({ message, accountId }: SetUrlParams): Promise<void> {
    if (this._imageUrlsSignal().hasOwnProperty(message.photoRemoteId)) { return; }

    const url = await this.telegramLoadFileService.loadImage({
      remoteId: message.photoRemoteId,
      accountId: accountId
    });

    this._imageUrlsSignal.update(current => ({
      ...current,
      [message.photoRemoteId]: url
    }));
  }
}
